import UnitManagementPage from '../components/UnitManagementPage'

export default function Courses() {
  return (
    <UnitManagementPage
      unitType="course"
      title="Kurse"
      description="Verwalten Sie Kurse für eine bessere Schülerorganisation"
      createButtonLabel="Neuer Kurs"
      searchPlaceholder="Nach Kursname, Fach oder Jahrgang suchen..."
    />
  )
}
